module.exports = __webpack_public_path__ + "img/success.84f9416c.png";